<template>
    <button v-if="previous_route_name" class="o-back" v-bind:class="{'o-back--at-rest': at_rest && !route_transition }" v-on:click="previousHighlight()">
        <svg class="o-back__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 500 500" style="enable-background:new 0 0 500 500;" xml:space="preserve">
            <g>
                <path d="M374.8,250.3c0-0.1,0.1-0.2,0.1-0.3s0-0.2-0.1-0.3c0-1.2-0.2-2.4-0.7-3.5c-0.3-0.6-0.7-1.2-1.1-1.7
                    c-0.3-0.5-0.5-1-0.9-1.4l-47.9-49.8c-3.8-4-10.1-4.1-14.1-0.3c-4,3.8-4.1,10.1-0.3,14.1l31.7,33H135.2c-5.5,0-10,4.5-10,10
                    s4.5,10,10,10h206.3l-31.7,33c-3.8,4-3.7,10.3,0.3,14.1c1.9,1.9,4.4,2.8,6.9,2.8c2.6,0,5.2-1,7.2-3.1l47.9-49.8
                    c0.4-0.4,0.6-0.9,0.9-1.4c0.4-0.6,0.8-1.1,1.1-1.7C374.5,252.6,374.7,251.5,374.8,250.3z"/>
                <path d="M250,4.4C114.6,4.4,4.4,114.6,4.4,250S114.6,495.6,250,495.6c135.4,0,245.6-110.2,245.6-245.6
                    S385.4,4.4,250,4.4z M250,475.7C125.6,475.7,24.3,374.5,24.3,250S125.6,24.3,250,24.3c124.4,0,225.7,101.2,225.7,225.7
                    S374.5,475.7,250,475.7z"/>
            </g>
        </svg>
    </button>
</template>

<script>
export default {
    data: function() {
        return {
            at_rest: false,
        }
    },
    mounted() {

        setTimeout(() => {
            this.at_rest = true;
        }, 2000);
    },
}
</script>
